import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: space-between;
  height: 2.6rem;
  border: 1px solid gray;
  padding: 0.4rem;

  * {
    font-size: 13px;
  }

  .name {
    font-weight: bold;
  }

  .badge-container {
    display: flex;
    gap: 0.3rem;
  }

  .trash {
    cursor: pointer;
    transform: scale(0.8);
    transition: all 200ms ease-in-out;

    &:hover {
      transform: scale(0.9);
    }
  }

  .badge {
    width: 5rem;
    padding: 0.3rem;
    display: grid;
    place-items: center;
    border-radius: 4px;
    font-weight: bold;
  }

  .registered {
    background: #16a34a;
    color: white;
  }

  .detached {
    background: #4b5563;
    color: white;
  }
`